const TOUR_STORAGE_PREFIX = "aq_qms_quiz_manager_tour_v1";

function getStorageKey(suffix, staffId) {
  const id = String(staffId || "").trim();
  return id
    ? `${TOUR_STORAGE_PREFIX}_${suffix}_${id}`
    : `${TOUR_STORAGE_PREFIX}_${suffix}`;
}

export function hasCompletedQmsQuizListTour(staffId) {
  try {
    return localStorage.getItem(getStorageKey("quiz_list", staffId)) === "1";
  } catch {
    return false;
  }
}

export function markQmsQuizListTourCompleted(staffId) {
  try {
    localStorage.setItem(getStorageKey("quiz_list", staffId), "1");
  } catch {
    /* ignore */
  }
}

export function hasCompletedQmsQuestionBankListTour(staffId) {
  try {
    return localStorage.getItem(getStorageKey("question_list", staffId)) === "1";
  } catch {
    return false;
  }
}

export function markQmsQuestionBankListTourCompleted(staffId) {
  try {
    localStorage.setItem(getStorageKey("question_list", staffId), "1");
  } catch {
    /* ignore */
  }
}

export function hasCompletedQmsQuestionFormTour(staffId) {
  try {
    return localStorage.getItem(getStorageKey("question_form", staffId)) === "1";
  } catch {
    return false;
  }
}

export function markQmsQuestionFormTourCompleted(staffId) {
  try {
    localStorage.setItem(getStorageKey("question_form", staffId), "1");
  } catch {
    /* ignore */
  }
}
